var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gc__icon"},[_c(_vm.iconType,{tag:"component",class:'gc__icon--' + _vm.size,attrs:{"color":_vm.iconColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }